// @ts-nocheck
import { Component, Input, OnInit, inject } from '@angular/core';
import { ASSETS } from '../../../assets/assets';
import { DatePickerComponent } from '../fields/date-picker/date-picker.component';
import { DateEditService } from './date-edit.service';

@Component({
  selector: 'lbca-date-edit',
  templateUrl: './date-edit.component.html',
  imports: [DatePickerComponent],
})
export class DateEditComponent implements OnInit {
  private dateEditService = inject(DateEditService);
  readonly assets = inject(ASSETS);

  rules = ['du>d'];
  disabledDateRules = [
    {
      rule: 'lt',
      conditions: {
        always: true,
      },
    },
  ];
  @Input('DateDue') dateDue: any;

  _canExceedFinalDate = false;
  @Input() set canExceedFinalDate(value) {
    if (value === true || value === 'true') {
      this._canExceedFinalDate = true;
    }
  }

  _dateDueFatal = null;
  @Input() set dateDueFatal(value) {
    this._dateDueFatal = value;
  }

  _workingDays = false;
  @Input() set workingDays(value) {
    if (value === true || value === 'true') {
      this._workingDays = true;
    }
  }
  public taskLabelsDict: Object = {};
  public label: Array<string> = '';

  ngOnInit(): void {
    this.taskLabelsDict = this.assets.labels.pages.task.taskForm;
    this.label = this.taskLabelsDict['label-date-edit'];
    this.dateEditService.setDate = this.dateDue;

    if (this._workingDays === true) {
      this.disabledDateRules = [
        ...this.disabledDateRules,
        {
          rule: 'sunday',
          conditions: {
            always: true,
          },
        },
        {
          rule: 'saturday',
          conditions: {
            always: true,
          },
        },
        {
          rule: 'holidays',
          conditions: {
            always: true,
          },
        },
      ];
    }

    if (this._dateDueFatal && !this._canExceedFinalDate) {
      this.disabledDateRules = [
        ...this.disabledDateRules,
        {
          rule: 'gtmx',
          conditions: {
            always: true,
          },
        },
      ];
      this.rules = [...this.rules, 'du<=mx'];
    }
  }

  changeDate(value: any) {
    this.dateEditService.setDate = value;
  }
}
